import { Component, ViewChild, inject, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { ButtonComponent } from "@components/button/button.component";
import { ListSelectedItemsComponent } from "@components/list-selected-items/list-selected-items.component";
import { PageComponent } from "@components/page/page.component";
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";
import { SelectedListItem } from "~app/common/components/list-selected-items/listSelectedItems.models";
import { AuthenticationService } from "~app/common/services/authentication/authentication.service";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { ProduktinstruktionerDownloadComponent } from "./produktinstruktioner-download/produktinstruktioner-download.component";
import { ProduktinstruktionerSearchResultComponent } from "./produktinstruktioner-search-result/produktinstruktioner-search-result.component";
import { ProduktinstruktionerSearchComponent } from "./produktinstruktioner-search/produktinstruktioner-search.component";

@Component({
    selector: "rask-produktinstruktioner",
    templateUrl: "./produktinstruktioner.component.html",
    styleUrls: ["./produktinstruktioner.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        PageComponent,
        ProduktinstruktionerSearchComponent,
        ProduktinstruktionerSearchResultComponent,
        ButtonComponent,
        NgbPopover,
        ListSelectedItemsComponent,
        ProduktinstruktionerDownloadComponent
    ]
})
export class ProduktinstruktionerComponent {
    downloadPinEvent: Subject<void> = new Subject<void>();
    massEditEvent: Subject<void> = new Subject<void>();
    @ViewChild(ProduktinstruktionerSearchResultComponent) searchResultView: ProduktinstruktionerSearchResultComponent;

    private readonly authenticationService = inject(AuthenticationService);
    private readonly router = inject(Router);

    readonly canCreate = () => this.authenticationService.canEdit();

    canMassEdit() {
        if (this.searchResultView?.searchResultTable != null) {
            return this.searchResultView.searchResultTable.getSelectedRows()?.length >= 2;
        }
        return false;
    }

    create = (): void => {
        this.router.navigate([
            "/produktinstruktioner",
            "ny"
        ]);
    };

    downloadPin() {
        this.downloadPinEvent.next();
    }

    edit() {
        this.massEditEvent.next();
    }

    getFileName  = (puid: string) => {
        const row = this.searchResultView.searchResultTable.getSelectedRows().find(x => x.puid === puid);
        return `${row.tradslag}_${row.namn}`;
    };

    getSelectedListItems() {
        return ObjectUtils.isNullOrUndefined(this.searchResultView?.selectedRows) ? [] : this.searchResultView?.selectedRows.map(x => new SelectedListItem(x.id, x.namn, true));
    }

    getSelectedPuids = () => this.searchResultView.searchResultTable.getSelectedRows().map(x => x.puid);

    removeFromSelection(item: SelectedListItem) {
        const filter = (result: any) => result.id === item.id;
        this.searchResultView?.searchResultTable?.removeItemFromSelectionList(filter);
        this.searchResultView?.onCheckedChange();
    }
}
